import Vue                            from 'vue'
import VueSweetalert2                 from 'vue-sweetalert2';
import App                            from './App.vue'
import Snotify, { SnotifyPosition }   from 'vue-snotify';
import 'vue-snotify/styles/material.css';

//-- VueSweetAlert2 = SWAL

const optionsSwal = {
  confirmButtonColor: '#595cde',
  cancelButtonColor: '#fd8b0d',
};

Vue.use(VueSweetalert2, optionsSwal);

//-- Vue-Snotify = Snotify

const optionsSnotify = {
  toast: {
    position: SnotifyPosition.rightTop
  }
}

Vue.use(Snotify, optionsSnotify);

//-- Multi-Select 
import VueSelectSides from "vue-select-sides";
Vue.use(VueSelectSides, {locale: "es_ES"});
Vue.component("vue-select-sides", VueSelectSides);
import "vue-select-sides/styles/themes/soft.scss";

//-- Importar Otros Módulos Adicionales
import igs_routes                       from '@/igs-routes/igs_routes'
import igs_store                        from '@/igs-store/igs_store'

//-- Elementos Visuales
import 'bootstrap'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import "./app.scss"

//-- Bootstrap
require('bootstrap');

//-- Importacion de JQuery
window.$ = window.jQuery = require('jquery');

//-- Determinar si estamos en modo Desarrollo / Producción
Vue.config.productionTip = false

//-- Variables de Acceso Global (y, generalmente, estático)
global.lnkAppName                   = "Panel iHoreca";                    //-- Nombre de la App
global.lnkAppVersion                = "1.04-250725"                       //-- Versión de la App

global.lnkServerAppURL              = 'https://app.ihoreca.es/app?';      //-- URL de acceso a los Datos del Servidor Remoto (Contenido)
global.lnkServerImgURL              = 'https://panel.ihoreca.es/img/';    //-- URL para Descarga de Imágenes
global.lnkServerRestURL             = 'https://panel.ihoreca.es/rest?';   //-- URL para Peticiones REST

global.lnkGetDataOk                 = 'ih1-OK';                           //-- Tag OK
global.lnkGetDataError              = 'ih1-ERROR';                        //-- Tag ERROR

global.lnkDateSeparator             = "-";                              //-- Separador para Fechas ("-", "/", ...)
global.lnkTimeSeparator             = ":";                              //-- Separador para Horas  (":", ...)

global.lnkMinDate                   = "00000101";                       //-- Fecha Mínima
global.lnkMaxDate                   = "99991231";                       //-- Fecha Máxima

//-- Máximo Número de Charts concurrentes (por tipología)
global.lnkMaxCharts                 = 10;
global.lnkMinimalChartObject        = JSON.parse(`{"ic1_opciones" : { "chart": { "type": "bar", "width":"100%", "toolbar": { "show": false }, "animations": { "enabled": false } } }, "ic1_series" : [ { "name" : "", "data" : []} ] }`);


//-- CSS (Paleta Colores)  (tc=Text Color // bc = Background Color)
global.lnkDefaultCSS                = '.ns-root { --tc0 : #ffffff; --tc1 : #595cde; --tc2 : #fd8b0d; --tc3 : #fd8b0d; --tc4 : #595cde; --tc5 : #fd8b0d; --tc6 : #ffffff; --tc7 : #7f7f7f; --tc8 : #dedede; --tc9 : #ffffff; --bc0 : #595cde; --bc1 : #595cde; --bc2 : #fd8b0d; --bc3 : #0369cf; --bc4 : #595cde; --bc5 : #ffffff; --bc6 : #fd8b0d; --bc7 : #7f7f7f; --bc8 : #dedede; --bc9 : #ffffff; }';
global.lnkDefaultLIC                = ["#595cde", "#595cde", "#fd8b0d", "#dedede", "#7f7f7f"];


//-----------------------------------------------------------------------------------------------
//-- Configurar RUTAS para ser usadas a lo largo de toda la App
//-----------------------------------------------------------------------------------------------
Vue.prototype.$lnkListaPaginas = igs_routes

//-----------------------------------------------------------------------------------------------
//-- Configurar STORE para ser usado a lo largo de toda la App
//-----------------------------------------------------------------------------------------------
Vue.prototype.$store = igs_store

/* eslint-disable */
const app = new Vue({
  render: h => h(App),
  router:igs_routes,
  store:igs_store,
  data: { },
  created() {
    window.addEventListener('resize', this.gp99HandleResize);
    this.gp99HandleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.gp99HandleResize);
  },
  mounted() {

    //console.log('### App Mounted ###  (Inicio)');

      //--------------------------------
      //-- Inicializar Chart Data
      //--------------------------------
      var i1 = 0;
      while (i1 < global.lnkMaxCharts) {
        var n1    = {};
        n1.indice = i1;
        n1.data   = global.lnkMinimalChartObject;

        this.$store.commit('p10StrT229M11106Add', n1);
        this.$store.commit('p10StrT229M11206Add', n1);
        this.$store.commit('p10StrT229M11306Add', n1);
        this.$store.commit('p10StrT229M11406Add', n1);
        this.$store.commit('p10StrT229M11506Add', n1);
        this.$store.commit('p10StrT229M11606Add', n1);

        this.$store.commit('p10StrT229M11616Add', n1);

        i1 += 1;
      }

    //console.log('### App Mounted ###  (Fin)');

    /*
    //-- Ejemplo de cómo llamar a Métodos VUE desde JQuery
    //-- Se puede llamar con app.XXXX a métodos locales definidos en la
    //-- instancia de VUE, y esos métodos locales Javascript (definidos en methods
    //-- durante la instanciación de VUE) ya ¡¡ pueden llamar a métodos VUE !!
    $(function() {
      $(document).on('click', '.alert-close', function() {
          //-- Ocultar Anuncio actual
          $(this).parent().hide();

          //-- Inicializar Texto
          if ($(this).parent()[0].id == 'igs-foot-alert') {
            app.gm10StrFootMsg();   //-- Pie (Footer)
          } else {
            app.gm10StrHeadMsg();   //-- Cabecera (Heading)
          }
      })
    });
    */
  },
  methods: {

    //-- Actualizar Ancho y Alto de la Ventana
    gp99HandleResize() {
      //console.log('-- gp99HandleResize --');
      //console.log(window.innerWidth + ' / '+window.innerHeight)
      this.$store.commit('p10StrScreenWidth', window.innerWidth);
      this.$store.commit('p10StrScreenHeight', window.innerHeight);
    }

    /*
    //-- Ejemplo de métodos locales JavaScript que realizan llamada
    //-- a métodos VUE. Con frecuencia estos métodos serán utilizados
    //-- por métodos y funciones JQuery

    //-- Global Method : Inicialización Texto del Mensaje de la parte superior (Heading)
    gm10StrHeadMsg: function() {
      //console.log('[gm10StrHeadMsg] ('+texto+')');
      //this.$store.commit('p10StrHeadMsgTexto', '');
    },
    //-- Global Method : Inicialización Texto del Mensaje de la parte inferior (Footer)
    gm10StrFootMsg: function() {
      //console.log('[gm10StrFootMsg] ('+texto+')');
      //this.$store.commit('p10StrFootMsgTexto', '');
  }
  */

}
}).$mount('#app')
/* eslint-enable */

//-- Iniciar la App en la Página Principal
igs_routes.replace('/')

//-- Comprobación de Arranque correcto de JQuery
// eslint-disable-next-line no-undef
$(document).ready(function () {
  //console.log('JQuery ¡¡ ON !!');

  //-- Ejemplo de llamada a método local Javascript (que, a su vez, realiza llamada a métodos VUE)
  //app.gm10StrHeadMsg('1234'); 
})



